// src/redux/features/documentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import configData from '../configure';

// Create async thunk for adding documents
export const addDocument = createAsyncThunk(
  'documents/addDocument',
  async ({ userId, documentData }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      
      // Add file to form data
      if (documentData.file) {
        formData.append('file', documentData.file);
      }
      
      // Add document details as a JSON string
      if (documentData.documentDetails) {
        formData.append('documentDetails', JSON.stringify(documentData.documentDetails));
      }
      
      const response = await axios.post(
        configData.get_identity_identity_users_document(userId),
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      
      return response.data;
    } catch (error) {
      // Extract the most useful error message
      let errorMessage = 'Failed to add document';
      
      if (error.response?.data) {
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = 'Server error: ' + JSON.stringify(error.response.data);
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      return rejectWithValue(errorMessage);
    }
  }
);

const documentSlice = createSlice({
  name: 'documents',
  initialState: {
    documents: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    clearDocumentError: (state) => {
      state.error = null;
      state.status = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addDocument.pending, (state) => {
        state.status = 'loading';
        state.error = null; // Clear previous errors when starting a new request
      })
      .addCase(addDocument.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Assuming the response includes the new document
        state.documents.push(action.payload);
      })
      .addCase(addDocument.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An unknown error occurred';
      });
  },
});

export const { clearDocumentError } = documentSlice.actions;
export default documentSlice.reducer;